<template>
  <div class="md-layout md-layout-item">
    <div class="md-card rounded-extreme">
      <div class="md-layout md-layout-item event-container">
        <div class="md-layout-item md-size-100">
          <h3 class="title md-layout-item md-size-100 text-primary bold">{{item.description.title}}</h3>
        </div>

        <div class="md-layout-item md-size-100 event-image">
          <img :src="imgUrl" @error="imgNotLoaded" />
        </div>

        <div class="md-layout-item md-size-100 event-details-container">
          <div style="font-size:14px;margin-top:10px" class="text-gray regular">
            <md-icon>schedule</md-icon>
            <span>
              <!-- <md-icon style="margin-right:10px">calendar_today</md-icon> -->
              {{item.startDate | moment("YYYY-MM-DD, HH:mm")}}
            </span>
          </div>
          <div style="font-size:14px;margin-top:10px" class="text-gray regular">
            <md-icon>people_alt</md-icon>
            <span>
              <!-- <md-icon style="margin-right:10px">calendar_today</md-icon> -->
              {{freeSpotsCount}}
            </span>
          </div>

          <div
            style="font-size:14px;margin-top:10px"
            class="text-gray regular"
            v-if="item.description.location"
          >
            <md-icon>location_city</md-icon>
            <span>{{item.description.location}}</span>
          </div>
        </div>
        <div class="md-layout md-layout-item md-size-100">
          <div class="ml-auto">
            <md-button
              v-if="canSignUp"
              @click.prevent="$emit('onSignUp')"
              class="md-round md-primary md-sm md-blue-border"
              style="margin:5px 5px"
            >{{$t('Sign up')}}</md-button>
            <md-button
              v-if="canSignOut"
              @click.prevent="$emit('onSignOut')"
              class="md-round md-primary md-sm md-blue-border"
              style="margin:5px 5px"
            >{{$t('Sign out')}}</md-button>
            <md-button
              @click.prevent="$emit('showDetails')"
              class="md-round md-primary md-sm md-blue-border"
              style="margin:5px 5px"
            >{{$t('Show details')}}</md-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "@/util/axios";
export default {
  props: ["item"],
  computed: {
    ...mapGetters({
      conference: "conference/current",
      language: "language/current",
      hasPartyAccess: "user/hasPartyAccess"
    }),
    description() {
      return this.item.description;
    },
    imgUrl() {
      return axios.getFileUrl(this.item.description.pictureFileId);
    },
    canSignUp() {
      return this.hasPartyAccess && this.item.canSignUp;
    },
    canSignOut() {
      return this.item.canSignOut;
    },
    freeSpotsCount() {
      var diff = this.item.limit - this.item.signedUpCount;
      return diff < 0 ? 0 : diff;
    }
  },
  data() {
    return {
      shadowNormal: {
        type: Boolean,
        default: false
      },
      noColoredShadow: {
        type: Boolean,
        default: false
      },
      imgLoaded: false
    };
  },
  methods: {
    imgNotLoaded(event) {
      if (!this.imgLoaded) {
        event.target.src = require("@/assets/img/cultural-event-placeholder.jpg");
      }
      this.imgLoaded = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.justify-content-center {
  justify-content: center !important;
}
.md-card {
  box-shadow: 0px 0px 30px #00000019;
}

.ended {
  color: red;
}
.current {
  color: green;
}
.md-icon {
  margin-left: 0px !important;
}
h3 {
  margin-top: 10px !important;
}
.event-details {
  margin-top: 16px;
  // vertical-align: text-top;
}
.event-details-container {
  margin-top: 24px;
  // align-self: flex-end;
}
.event-image {
  align-self: center;
  margin-top: 12px;
}
.event-container {
  padding: 10px 20px 20px 20px;
}
</style>



